import React, { Component, Fragment } from 'react';
import { HeaderTab } from '@keethealth/keet-ui';
import { graphql, compose } from 'react-apollo';
import queries from 'graph/queries';
import PropTypes from 'prop-types';

import PATIENT_RECORD from 'graph/queries/patientRecord';
import shiLogo from 'assets/images/SHI-Logo.png';
import ObservationModal from 'common/ObservationSummary/ObservationModal';
import HeaderProfile from './HeaderProfile';
import HeaderMobile from './HeaderMobile';
import MessageBadge from './MessageBadge';
import '../header.css';

export class Header extends Component {
  static defaultProps = {
    carePlans: [
      {
        id: '',
      },
    ],
    patientRecord: {},
  }

  static propTypes = {
    patientRecord: PropTypes.shape({
      organization: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
      })),
    }),
    carePlans: PropTypes.arrayOf(
      PropTypes.shape({
        carePlanActivities: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            required: PropTypes.bool,
          }),
        ),
      }),
    ).isRequired,
  }

  state = {
    isModalOpen: false,
  }

  toggleModal = () => {
    const { isModalOpen } = this.state;
    this.setState({
      isModalOpen: !isModalOpen,
    });
  }

  renderTabs = () => {
    const menu = [
      {
        key: 'my_tasks',
        to: '/my_tasks',
        title: 'My Tasks',
      },
      {
        key: 'progress',
        to: '/progress',
        title: 'Progress',
      },
      {
        key: 'history',
        to: '/history',
        title: 'History',
      },
      {
        key: 'education',
        to: '/education',
        title: 'Education',
      },
      {
        key: 'messages',
        to: '/messages',
        title: (
          <MessageBadge>
            Messages
          </MessageBadge>
        ),
      },
    ];
    return menu.map(props => (
      <HeaderTab {...props} />
    ));
  }

  render() {
    const { carePlans, patientRecord: { organization } } = this.props;
    const { isModalOpen } = this.state;

    return (
      <Fragment>
        <header id="keet-header" className="bg-white bb fw3 f5">
          <div className="mw8 w-100 center flex flex-shrink-0 items-center content-between">
            <div className="flex w-100 items-center justify-center">
              <div className="flex flex-auto pl3">
                <div className="db">
                  <img id="header-logo" src={shiLogo} alt="keet-logo" />
                  {organization &&
                    <div className="tc f5 mt1 bt">
                      {organization.name}
                    </div>
                  }
                </div>
              </div>
              <div className="dn db-l">
                <div className="flex">
                  <div className="br flex fw4">
                    {this.renderTabs()}
                  </div>
                  <HeaderProfile toggleModal={this.toggleModal} />
                </div>
              </div>
            </div>
            <div className="w-100 db dn-ns db-m dn-l">
              <HeaderMobile toggleModal={this.toggleModal} />
            </div>
          </div>
        </header>
        {carePlans &&
          <ObservationModal
            carePlanId={carePlans[0].id}
            isModalOpen={isModalOpen}
            toggleModal={this.toggleModal}
          />
        }
      </Fragment>
    );
  }
}

export default compose(
  graphql(queries.carePlansIncomplete, {
    options: { fetchPolicy: 'cache-and-network' },
    props: ({ data: { loading, carePlans } }) => ({
      carePlans,
      loading,
    }),
  }),
  graphql(PATIENT_RECORD, {
    options: { fetchPolicy: 'cache-and-network' },
    props: ({ data: { patientRecord } }) => ({
      patientRecord,
    }),
  }),
)(Header);
